
const actionsTypesQuestions={
    LOADING :"LOADING",
    LOAD_SUCCESS:"LOAD_SUCCESS",
    LOAD_FAILURE:"LOAD_FAILURE"
}


export default actionsTypesQuestions